export const SCOPE = {
  NEED_PACKING : 'need_packing',
  READY_TO_SHIP : 'ready_to_ship',
  SENT : 'sent',
  ALL : 'all'
}

export const CATEGORIES = {
  OFFLINE : 'offline',
  ONLINE  : 'online'
}

export const PER_PAGE_OPTIONS = [
  {
    'label' : '10',
    'value' : '10'
  },
  {
    'label' : '25',
    'value' : '25'
  },
  {
    'label' : '50',
    'value' : '50'
  },
  {
    'label' : '100',
    'value' : '100'
  }
]

export const SORT_OPTIONS = [
  {
    'id'       : 1,
    'label'    : 'Pickup Tercepat',
    'sort_by'  : 'deals.pickup_at',
    'sort_dir' : 'asc'
  },
  {
    'id'       : 2,
    'label'    : 'Pickup Terakhir',
    'sort_by'  : 'deals.pickup_at',
    'sort_dir' : 'desc'
  },
  {
    'id'       : 3,
    'label'    : 'Dibuat Terawal',
    'sort_by'  : 'deals.created_at',
    'sort_dir' : 'asc'
  },
  {
    'id'       : 4,
    'label'    : 'Dibuat Terakhir',
    'sort_by'  : 'deals.created_at',
    'sort_dir' : 'desc'
  },
]
